import { mapActions, mapGetters } from 'vuex';
import fbIcon from '@/assets/icons/footer/old/facebook.svg';
import instaIcon from '@/assets/icons/footer/old/instagram.svg';
import twitterIcon from '@/assets/icons/footer/old/twitter.svg';
import { MODALS } from '@/components/app/app-modals/app-modals';

export default {
  data() {
    return {
      items: [
        { title: 'Facebook', href: process.env.PI_FACEBOOK_LINK, icon: fbIcon },
        { title: 'Instagram', href: process.env.PI_INSTAGRAM_LINK, icon: instaIcon },
        { title: 'Twitter', href: process.env.PI_TWITTER_LINK, icon: twitterIcon },
      ],
    };
  },
  computed: {
    ...mapGetters('user', ['isUserRestricted']),
  },
  methods: {
    ...mapActions('popup', ['setCurrentPopup']),
    onLearnMore() {
      this.setCurrentPopup(MODALS.RESEARCH);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/app/app-footer/app-footer.js